import { constants } from "../../common/constant/constants";
import { HttpHelper } from "../../common/helper/http-helper-service";
import { ProjectPaginationValues } from "../../common/model/project/project-pagination-values";

export interface ProjectTask {
  projectId: string;
  sectionId: string;
  title: string;
  statusId: number;
  leadTechnicianId?: number | null;
  secondaryTechnicianIds: number[];
  watcherIds?: number[];
  dueDate: string | null;
  priorityId: number;
  recentActivity: any;
  sortOrder: number | null;
}
export default class projectService {
  static GetProjectList(pagination: ProjectPaginationValues) {
    return HttpHelper.getData(
      constants.apiUrl.projectUrls.getProjectList,
      pagination,
    );
  }

  static getProjectTypeList = () => {
    return HttpHelper.getData(constants.apiUrl.projectUrls.getProjectTypeList);
  };

  static getProjectById = (projectId: number) => {
    return HttpHelper.getData(
      constants.apiUrl.projectUrls.getProjectById.replace(
        "{projectId}",
        projectId.toString(),
      ),
    );
  };
}
